import "./LoadingState.css"
import LoadingIndicator from "../loadingIndicator/LoadingIndicator";
import adaptiveSize from "../../utils/size";

export default function LoadingState(props) {
    const text = props.text
    const resolutionUnit = props.resolutionUnit
    const size = adaptiveSize(resolutionUnit, 2.4);
    const fontSize = adaptiveSize(resolutionUnit, 1.4);
    return (
        <div className="h-100 w-full flex justify-center flex-col gap-6">
            <div role="status">
                <LoadingIndicator
                    widith={size}
                    height={size}
                />
                <span className="sr-only">Loading...</span>
            </div>
            <p
                className="font-bold"
                style={{fontSize: `${fontSize}px`}}
            >
                {text}
            </p>
        </div>
    )
}